export default {
  name: "EventOrganizerListTable",
  props: ["organizer", "headers", "filter", "count"],
  data: () => ({
    tableOptions: { itemsPerPage: 10 },
    pageCount: 0,
    itemsPerPage: 10,
    page: 1
  }),
  methods: {
    nextPage() {
      const total = this.count || 0;
      const totalPages = Math.ceil(total / this.itemsPerPage);

      if (this.page < totalPages) {
        this.page++;
        this.tableOptions.page = this.page;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
        this.tableOptions.page = this.page;
      }
    },
    getTypes(types) {
      types = types.map(type =>
        type === "operator" ? "Veranstalter" : "Standort"
      );
      return types.join(",");
    }
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  watch: {
    tableOptions(value) {
      const nextFilter = {
        ...(this.filter || {}),
        limit: value.itemsPerPage,
        page: value.page
      };

      const sortDirection = value?.sortDesc?.[0] ? ":desc" : ":asc";
      const sortBy = value.sortBy?.[0] ?? "title_asc";

      if (sortBy === "title")
        nextFilter.sortOption = sortBy + "_asc" + sortDirection;
      else nextFilter.sortOption = sortBy + sortDirection;
      this.$emit("applyFilter", nextFilter);
    }
  }
};
